import { useEffect, useMemo } from "react";
import { useTimer } from "react-timer-hook";

import { formatTime } from "@/shared-utils/formatters";

import { ElapsedTimeValue } from "./ElapsedTimeValue";

export function CountdownTimer({ endAt, includeUnit = false }: { endAt: number | undefined; includeUnit?: boolean }) {
    // Guard undefined/NaN so a missing timestamp renders a blank placeholder, not a misleading "00".
    const isValidEndAt = typeof endAt === "number" && Number.isFinite(endAt);
    const expiryDate = useMemo(() => (isValidEndAt ? new Date(endAt) : new Date()), [endAt, isValidEndAt]);
    const { totalSeconds, restart } = useTimer({ expiryTimestamp: expiryDate });
    const formattedTimeLeft =
        totalSeconds >= 60
            ? formatTime(totalSeconds, includeUnit, "m:ss")
            : formatTime(totalSeconds, includeUnit, "ss");
    const [timeValue, timeUnit] = formattedTimeLeft.split(" ");

    useEffect(() => {
        restart(expiryDate);
    }, [endAt, expiryDate, restart]);

    if (!isValidEndAt) {
        return <ElapsedTimeValue value="" unit="" size="xxs" />;
    }

    return <ElapsedTimeValue value={timeValue} unit={timeUnit} size="xxs" />;
}
